"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../../../assets/constants/constants");
const countriesArray_1 = require("../../../../../assets/constants/countriesArray");
const PerfilStyles_1 = require("../../PerfilStyles");
const PersonalInformationsStyles_1 = require("./PersonalInformationsStyles");
const PersonalInformations = ({ user, open, setOpen, form }) => {
    (0, react_1.useEffect)(() => {
        form.setFieldsValue({
            firstName: user.firstName,
            lastName: user.lastName,
            birthDate: user.birthDate ? (0, moment_1.default)(user.birthDate).format('DD/MM/yyyy') : '',
            genre: user.genre,
            country: user.country,
            state: user.state,
        });
    }, [form, user]);
    return (react_1.default.createElement(PersonalInformationsStyles_1.ContainerForm, { form: form },
        react_1.default.createElement(PerfilStyles_1.Text, { id: "mobile-subtitle", decoration: "500" }, "Queremos saber mais sobre voc\u00EA! :)"),
        react_1.default.createElement(PerfilStyles_1.Group, { wrapper: true },
            react_1.default.createElement(PerfilStyles_1.Group, null,
                react_1.default.createElement(PerfilStyles_1.Text, null, "Nome *"),
                react_1.default.createElement(PersonalInformationsStyles_1.StyledFormItem, { name: "firstName" },
                    react_1.default.createElement(PerfilStyles_1.InputStyled, null))),
            react_1.default.createElement(PerfilStyles_1.Group, null,
                react_1.default.createElement(PerfilStyles_1.Text, null, "Sobrenome *"),
                react_1.default.createElement(PersonalInformationsStyles_1.StyledFormItem, { name: "lastName" },
                    react_1.default.createElement(PerfilStyles_1.InputStyled, null)))),
        react_1.default.createElement(PerfilStyles_1.Group, { wrapper: true },
            react_1.default.createElement(PerfilStyles_1.Group, null,
                react_1.default.createElement(PerfilStyles_1.Text, null, "Data de nascimento"),
                react_1.default.createElement(PersonalInformationsStyles_1.StyledFormItem, { name: "birthDate", validateTrigger: "onBlur", rules: [
                        () => ({
                            validator(rule, value) {
                                if (!value) {
                                    return Promise.resolve();
                                }
                                const dateFormat = 'DD/MM/YYYY';
                                const inputDate = (0, moment_1.default)(value, dateFormat, true);
                                if (!(0, moment_1.default)(inputDate).isValid()) {
                                    return Promise.reject(new Error('Insira uma data válida'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ] },
                    react_1.default.createElement(PerfilStyles_1.MaskInputStyled, { type: "tel", mask: "11/11/1111", placeholder: "dd/mm/aaaa" }))),
            react_1.default.createElement(PerfilStyles_1.Group, null,
                react_1.default.createElement(PerfilStyles_1.Text, null, "G\u00EAnero"),
                react_1.default.createElement(PersonalInformationsStyles_1.StyledFormItem, { name: "genre" },
                    react_1.default.createElement(PerfilStyles_1.RadioStyled, null,
                        react_1.default.createElement(antd_1.Radio, { value: "1" }, "Masculino"),
                        react_1.default.createElement(antd_1.Radio, { value: "2" }, "Feminino"),
                        react_1.default.createElement(antd_1.Radio, { value: "3" }, "Outros"))))),
        react_1.default.createElement(PerfilStyles_1.Group, { wrapper: true },
            react_1.default.createElement(PerfilStyles_1.Group, null,
                react_1.default.createElement(PerfilStyles_1.Text, null, "Pa\u00EDs * "),
                react_1.default.createElement(PersonalInformationsStyles_1.StyledFormItem, { name: "country" },
                    react_1.default.createElement(PerfilStyles_1.SelectStyled, { size: "large", value: user.country }, countriesArray_1.COUNTRIES.map(country => (react_1.default.createElement(PerfilStyles_1.SelectStyled.Option, { value: country.sigla3, key: country.codigo, defaultChecked: true }, country.nome)))))),
            react_1.default.createElement(PerfilStyles_1.Group, null,
                react_1.default.createElement(PerfilStyles_1.Text, null, "Estado *"),
                react_1.default.createElement(PersonalInformationsStyles_1.StyledFormItem, { name: "state" }, form.getFieldValue('country') === 'BRA' ? (react_1.default.createElement(PerfilStyles_1.SelectStyled, { value: user.state, size: "large" }, constants_1.STATES.map(state => (react_1.default.createElement(PerfilStyles_1.SelectStyled.Option, { key: state.initials, value: state.initials }, state.state))))) : (react_1.default.createElement(PerfilStyles_1.InputStyled, null))))),
        react_1.default.createElement("hr", { className: "mobile-divider" })));
};
exports.default = PersonalInformations;
